import { render } from "./HeroiconsOutlineVideoCamera.vue?vue&type=template&id=5d9f1e3e"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineVideoCamera.vue"]])

export default __exports__